import { isObject } from "lodash"

export const PeopleAction = (props) => {
  const {
    device,
    actionable,
    canCreate,
    onEdit = () => {},
    onAdd = () => {},
    onRemove = () => {},
  } = props

  if (device && isObject(device)) {
    return <>
      <button className="btn btn-primary" onClick={() => onEdit()}>
        View/Edit
      </button>
      <button className="d-inline btn btn-remove btn-remove--lg ml-2" onClick={() => onRemove()}>
        <i className="fal fa-trash"></i>
      </button>
    </>
  }

  if (actionable || canCreate) {
    return <>
      <button className="d-inline btn btn-add btn-add--lg" onClick={() => onAdd()}>
        <i className="fal fa-plus"></i>
      </button>
      <button className="d-inline btn btn-remove btn-remove--lg ml-2" onClick={() => onRemove()}>
        <i className="fal fa-trash"></i>
      </button>
    </>
  }

  return <button className="d-inline btn btn-remove btn-remove--lg ml-2" onClick={() => onRemove()}>
    <i className="fal fa-trash"></i>
  </button>
}
